(() => {
  const SCROLL_THRESHOLD = 50;
  const SCROLLED_CLASS = "scrolled";
  const DROPDOWN_CLOSED_CLASS = "dropdown-closed";

  const headerAnnouncements = document.querySelector(".header-announcements");
  const accountTrigger = document.querySelector(".header-announcements__account");
  const loginButton = document.querySelector(".header-announcements__login-button");

  if (!headerAnnouncements) return;

  let isScrolled = false;
  let hasScrolledEver = false;
  let lastScrollY = window.scrollY;

  function handleScroll() {
    hasScrolledEver = true;
    const currentScrollY = window.scrollY;

    // Close dropdown when scrolling down (mobile only - desktop uses hover)
    if (currentScrollY > lastScrollY && accountTrigger && window.innerWidth < 750) {
      accountTrigger.classList.remove("is-open");
      if (headerAnnouncements) {
        headerAnnouncements.classList.add(DROPDOWN_CLOSED_CLASS);
      }
    }

    lastScrollY = currentScrollY;

    const shouldBeScrolled = window.scrollY > SCROLL_THRESHOLD;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;
      if (headerAnnouncements) {
        headerAnnouncements.classList.toggle(SCROLLED_CLASS, isScrolled);
      }
    }
  }

  /**
   * @param {MouseEvent} event
   */
  function handleAccountClick(event) {
    // Desktop: Let the link navigate normally, hover shows dropdown
    if (window.innerWidth >= 750) {
      return;
    }

    // Don't handle clicks on dropdown links - let them navigate
    const targetElement = /** @type {HTMLElement | null} */ (event.target);
    if (targetElement && targetElement.closest(".header-announcements__dropdown-item")) {
      return;
    }

    // On mobile: Prevent navigation and toggle dropdown (original behavior)
    event.preventDefault();
    event.stopPropagation();

    if (accountTrigger) {
      // Toggle the dropdown
      accountTrigger.classList.toggle("is-open");

      // Remove dropdown-closed class when opening
      if (accountTrigger.classList.contains("is-open") && headerAnnouncements) {
        headerAnnouncements.classList.remove(DROPDOWN_CLOSED_CLASS);
      }
    }
  }

  /**
   * @param {MouseEvent} event
   */
  function handleClickOutside(event) {
    // Close dropdown when clicking outside
    if (accountTrigger && !accountTrigger.contains(/** @type {Node} */ (event.target))) {
      accountTrigger.classList.remove("is-open");
    }
  }

  /**
   * Handle dropdown link clicks - allow navigation to proceed
   * @param {MouseEvent} event
   */
  function handleDropdownLinkClick(event) {
    // Stop propagation so the click doesn't trigger handleAccountClick
    event.stopPropagation();

    // Allow the link to navigate normally
    // Close dropdown after a short delay to allow navigation to start
    setTimeout(() => {
      if (accountTrigger) {
        accountTrigger.classList.remove("is-open");
      }
    }, 100);
  }

  function initScrollHandler() {
    window.addEventListener("scroll", handleScroll, { passive: true });
    
    if (accountTrigger) {
      const accountLink = accountTrigger.querySelector(".header-announcements__account-link");
      const isMobile = window.innerWidth < 750;
      
      if (isMobile && accountLink) {
        accountLink.addEventListener("click", handleAccountClick);

        const dropdownLinks = accountTrigger.querySelectorAll(".header-announcements__dropdown-item");
        dropdownLinks.forEach((link) => {
          link.addEventListener("click", handleDropdownLinkClick);
        });
        
        document.addEventListener("click", handleClickOutside);
      }
    }

    if (loginButton) {
      loginButton.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollHandler);
  } else {
    initScrollHandler();
  }
})();
